import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxContextMenuModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxFormModule, DxListModule, DxPopoverModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule, DxTabPanelModule, DxTagBoxModule, DxTextBoxModule, DxTreeViewModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProjectListComponent } from './project-list/project-list.component';
import { HomeRoutingModule } from './home-routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AutoCompleteModule } from 'primeng/autocomplete';

// import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ScrollerModule } from 'primeng/scroller';


@NgModule({ declarations: [
        ProjectListComponent,
        LandingPageComponent,
    ],
    exports: [
        ProjectListComponent
    ], imports: [CommonModule,
        HomeRoutingModule,
        DxScrollViewModule,
        DxDataGridModule,
        DxDateBoxModule,
        DxButtonModule,
        DxFormModule,
        DxSelectBoxModule,
        DxTagBoxModule,
        DxRadioGroupModule,
        DxCheckBoxModule,
        DxTreeViewModule,
        DxContextMenuModule,
        DxPopoverModule,
        DxTabPanelModule,
        DxAutocompleteModule,
        ReactiveFormsModule,
        DxListModule,
        DxTextBoxModule,
        DxDropDownBoxModule,
        AutoCompleteModule,
        ScrollerModule,
        FormsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class HomeModule { }
